import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
const ease = [0.23, 1, 0.32, 1] as const;
const HOLD = 2000;
const OPEN = 760;
const CURTAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/mcgbzfneeRV5YeFH79Mhwg/cortina_reina_2.png';
export function Curtain() {
  const {
    t
  } = useLanguage();
  const [visible, setVisible] = useState(true);
  const [opening, setOpening] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setVisible(false);
      return;
    }
    document.body.style.overflow = 'hidden';
    const openTimer = window.setTimeout(() => setOpening(true), HOLD);
    const endTimer = window.setTimeout(() => setVisible(false), HOLD + OPEN);
    return () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(endTimer);
      document.body.style.overflow = '';
    };
  }, []);
  useEffect(() => {
    if (!visible) document.body.style.overflow = '';
  }, [visible]);
  return <AnimatePresence data-id="element-49" data-mp="mtbpcqosdth6">
      {visible && <div className="pointer-events-none fixed inset-0 z-[120] overflow-hidden bg-[#050403]" role="status" aria-live="polite" aria-label={t.a11y.loading} data-id="element-50" data-mp="msjvpler25tj">
          <motion.div className="absolute inset-0" initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-51" data-mp="rmebidr8i0nc">
            <motion.div className="absolute inset-y-0 left-0 w-1/2 overflow-hidden" initial={{
          x: 0
        }} animate={{
          x: opening ? '-101%' : 0
        }} transition={{
          duration: OPEN / 1000,
          ease
        }} data-id="element-52" data-mp="3txt223l46ni">
              <img src={CURTAIN_IMAGE} alt="" aria-hidden="true" className="absolute left-0 top-0 h-full w-screen max-w-none object-cover" data-id="element-53" data-mp="dqk8uch207io" />
              <span aria-hidden="true" className="absolute inset-y-0 right-0 w-px bg-[linear-gradient(to_bottom,transparent,rgba(255,244,194,0.75),transparent)]" data-id="element-54" data-mp="1p7ajq8wf9nim" />
            </motion.div>

            <motion.div className="absolute inset-y-0 right-0 w-1/2 overflow-hidden" initial={{
          x: 0
        }} animate={{
          x: opening ? '101%' : 0
        }} transition={{
          duration: OPEN / 1000,
          ease
        }} data-id="element-55" data-mp="3gc405ahi3n8u">
              <img src={CURTAIN_IMAGE} alt="" aria-hidden="true" className="absolute right-0 top-0 h-full w-screen max-w-none object-cover" data-id="element-56" data-mp="3qajlewtuk2af" />
              <span aria-hidden="true" className="absolute inset-y-0 left-0 w-px bg-[linear-gradient(to_bottom,transparent,rgba(255,244,194,0.75),transparent)]" data-id="element-57" data-mp="2xlmbbgzshbsr" />
            </motion.div>

            <span aria-hidden="true" className="curtain-sweep pointer-events-none absolute inset-0" data-id="element-58" data-mp="36m2dmn4sqcw1" />
          </motion.div>

          <motion.div className="absolute inset-x-0 bottom-16 flex justify-center" animate={{
        opacity: opening ? 0 : 1
      }} transition={{
        duration: 0.24,
        ease
      }} data-id="element-59" data-mp="2ivy7a8083z1c">
            <div className="h-px w-40 overflow-hidden bg-gold-deep/30 sm:w-56" data-id="element-60" data-mp="24qef323wn412">
              <motion.span className="block h-full origin-left bg-[linear-gradient(90deg,#8a6d3b,#f0d894,#fff4c2)]" initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: (HOLD - 300) / 1000,
            ease: 'linear',
            delay: 0.3
          }} data-id="element-61" data-mp="29ho6o890khfl" />
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}